module.exports = __webpack_public_path__ + "static/media/tvoc.fc0d4c9b.jpg";